// extracted by mini-css-extract-plugin
export var alignCenter = "survey-question-module--align-center--tQKgc";
export var answersWrapper = "survey-question-module--answers-wrapper--DUc5d";
export var circleGrid = "survey-question-module--circleGrid--z9S7C";
export var counter = "survey-question-module--counter--6Enjc";
export var descriptionWrapper = "survey-question-module--description-wrapper--Wud3d";
export var error = "survey-question-module--error--gDvBW";
export var heart = "survey-question-module--heart--SS5b1";
export var hoverGrid = "survey-question-module--hoverGrid--wG4JV";
export var imageText = "survey-question-module--image-text--YeCMY";
export var negative = "survey-question-module--negative--jvezi";
export var optionIcon = "survey-question-module--option-icon--OLUml";
export var questionHint = "survey-question-module--question-hint--JrgK+";
export var questionImg = "survey-question-module--question-img--HKUQf";
export var questionImgWrapper = "survey-question-module--question-img-wrapper--0cKnx";
export var questionSubtitle = "survey-question-module--question-subtitle--BK-G0";
export var questionTitle = "survey-question-module--question-title--2ji2y";
export var questionWrapper = "survey-question-module--question-wrapper--7m1l6";
export var selectMulti = "survey-question-module--select-multi--nwqCv";
export var squareGrid = "survey-question-module--squareGrid--A+4rL";
export var squareGridNoText = "survey-question-module--squareGridNoText--ZH6EQ";
export var text = "survey-question-module--text--ajDVS";